/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_USER_PROFILE = '[Account] Get User Profile',
  GET_USER_PROFILE_SUCCESS = '[Account] Get User Profile Success',
  GET_USER_PROFILE_FAILED = '[Account] Get User Profile Failed',

  GET_APPLICANT_DETAILS = '[Account] Get Applicant Details',
  GET_APPLICANT_DETAILS_SUCCESS = '[Account] Get Applicant Details Success',
  GET_APPLICANT_DETAILS_FAILED = '[Account] Get Applicant Details Failed',

  VERIFY_APPLICATION = '[Account] Verify Applciation',
  VERIFY_APPLICATION_SUCCESS = '[Account] Verify Applciation Success',
  VERIFY_APPLICATION_FAILED = '[Account] Verify Applciation Failed',

  TRANSMIT_APPLICATION = '[Account] Transmit Applciation',
  TRANSMIT_APPLICATION_SUCCESS = '[Account] Transmit Applciation Success',
  TRANSMIT_APPLICATION_FAILED = '[Account] Transmit Applciation Failed',
}

export const getUserProfile = createAction(
  ActionTypes.GET_USER_PROFILE
);

export const getUserProfileSuccess = createAction(
  ActionTypes.GET_USER_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const getUserProfileFailed = createAction(
	ActionTypes.GET_USER_PROFILE_FAILED,
  props<{ data: any }>()
);

export const getApplicantDetails = createAction(
  ActionTypes.GET_APPLICANT_DETAILS,
  props<{ uuid: any, redirect: Boolean, tranType: any }>()
);

export const getApplicantDetailsSuccess = createAction(
  ActionTypes.GET_APPLICANT_DETAILS_SUCCESS,
  props<{ data: any, redirect: Boolean, tranType: any }>()
);

export const getApplicantDetailsFailed = createAction(
	ActionTypes.GET_APPLICANT_DETAILS_FAILED,
  props<{ data: any }>()
);

export const verifyApplication = createAction(
  ActionTypes.VERIFY_APPLICATION,
  props<{ uuid: string }>()
);

export const verifyApplicationSuccess = createAction(
  ActionTypes.VERIFY_APPLICATION_SUCCESS,
  props<{ data: any }>()
);

export const verifyApplicationFailed = createAction(
  ActionTypes.VERIFY_APPLICATION_FAILED,
  props<{ data: any }>()
);

export const transmitApplication = createAction(
  ActionTypes.TRANSMIT_APPLICATION,
  props<{ uuid: string }>()
);

export const transmitApplicationSuccess = createAction(
  ActionTypes.TRANSMIT_APPLICATION_SUCCESS,
  props<{ data: any }>()
);

export const transmitApplicationFailed = createAction(
  ActionTypes.TRANSMIT_APPLICATION_FAILED,
  props<{ data: any }>()
);